import { 
  FETCH_FACILITIES_SUCCESS, 
  FETCH_FACILITIES_FAILURE, 
  FETCH_FACILITIES_LOADING,
  SET_SELECTED_FACILITY,
  FACILITY_SWITCH_LOADING
} from "../types/type";


const savedFacility = localStorage.getItem("selectedFacility");

const initialState = {
  facilities: [],
  loading: false,
  error: null,
  selectedFacility: savedFacility ? JSON.parse(savedFacility) : null
};

const facilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FACILITIES_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FACILITY_SWITCH_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case FETCH_FACILITIES_SUCCESS:
      return {
        ...state,
        facilities: action.payload,
        loading: false,
        error: null
      };
    case FETCH_FACILITIES_FAILURE:
      return {
        ...state,
        facilities: [],
        loading: false,
        error: action.payload
      };
    case SET_SELECTED_FACILITY:
      return {
        ...state,
        selectedFacility: action.payload
      };
    default:
      return state;
  }
};

export default facilityReducer;

